const customEditor = {
  "sticker-maker": {
    config: {
      id: "hmlv-dcs-001",
      name: "stickers",
      mockup: {
        size: {
          width: 1600,
          height: 1600,
        },
        layers: {
          background: false,
          mockup: false,
          masks: false,
          design: true,
        },
      },
      design: [
        {
          id: "design-1",
          position: {
            x: 100,
            y: 100,
          },
          transform: {
            rotate: 0,
          },
          size: {
            width: 1200,
            height: 1200,
          },
        },
      ],
      meta: {
        category: "home-and-living",
        subcategories: ["sticker"],
        tags: ["square", "non zip", "stickers"],
      },
    },
  },
};

export function getConfigOfCustomEditor(key) {
  if (Object.hasOwn(customEditor, key)) {
    return customEditor[key].config;
  } else return null;
}
